<mat-form-field>
  <mat-label>{{ label$ | async }}</mat-label>
  <mat-select [formControl]="formControl">
    <mat-option *ngFor="let item of items" [value]="item.value">
      {{ item.label }}
    </mat-option>
  </mat-select>
</mat-form-field>
